<a *ngIf="!divider; else dividerElement" class="dropdown-item" [class.active]="active">
  <fa-icon *ngIf="icon != null" [icon]="icon" class="text-muted mr-2"/>
  <span><ng-content></ng-content></span>
</a>

<ng-template #dividerElement>
  <div class="dropdown-divider"></div>
</ng-template>
